<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('recharge.userId')" prop="userId" >
        <a-input v-model="form.userId" :placeholder="$t('recharge.inputUserId')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.orderNo')" prop="orderNo" >
        <a-input v-model="form.orderNo" :placeholder="$t('recharge.inputOrderNo')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.payNo')" prop="payNo" >
        <a-input v-model="form.payNo" :placeholder="$t('recharge.inputPayNo')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.outTrandNo')" prop="outTrandNo" >
        <a-input v-model="form.outTrandNo" :placeholder="$t('recharge.inputOutTrandNo')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.rechargeDiamond')" prop="rechargeDiamond" >
        <a-input v-model="form.rechargeDiamond" :placeholder="$t('recharge.inputRechargeDiamond')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.payMoney')" prop="payMoney" >
        <a-input v-model="form.payMoney" :placeholder="$t('recharge.inputPayMoney')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.menuId')" prop="menuId" >
        <a-input v-model="form.menuId" :placeholder="$t('recharge.inputMenuId')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.payTime')" prop="payTime" >
        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.statusLabel')" prop="status" >
      </a-form-model-item>
      <a-form-model-item :label="$t('recharge.remark')" prop="remark" >
        <a-input v-model="form.remark" :placeholder="$t('recharge.inputContent')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrder, addOrder, updateOrder } from '@/api/recharge/order'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        orderNo: null,

        payNo: null,

        outTrandNo: null,

        rechargeDiamond: null,

        payMoney: null,

        menuId: null,

        payTime: null,

        status: 0,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        userId: [
          { required: true, message: this.$t('recharge.userIdRequired') }
        ],
        orderNo: [
          { required: true, message: this.$t('recharge.orderNoRequired') }
        ],
        payMoney: [
          { required: true, message: this.$t('recharge.payMoneyRequired') }
        ],
        status: [
          { required: true, message: this.$t('recharge.statusRequired') }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        orderNo: null,
        payNo: null,
        outTrandNo: null,
        rechargeDiamond: null,
        payMoney: null,
        menuId: null,
        payTime: null,
        status: 0,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrder(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrder(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
